// extracted by mini-css-extract-plugin
export default {"wrapper":"page_wrapper__j2Vnc","modal":"page_modal__kZtyX"};